// extracted by mini-css-extract-plugin
export default {"container":"VisitorCounter_container__SbABb","instructions":"VisitorCounter_instructions__FqzPy","btnGroup":"VisitorCounter_btnGroup__KoOUc"};